import { useEffect } from 'react';
import { tsmLanguagesLoader } from './tsm/tsmLanguagesLoader';
import { isTSMEnabled } from './tsm/tsmHelpers';
export const LanguagesLoader = ({
  onLoad
}) => {
  useEffect(() => {
    if (!isTSMEnabled()) {
      onLoad();
      return undefined;
    }
    let hasAppUnmounted = false;
    tsmLanguagesLoader().then(() => !hasAppUnmounted && onLoad());
    return () => {
      hasAppUnmounted = true;
    };
  }, [onLoad]);
  return null;
};
LanguagesLoader.displayName = 'LanguagesLoader';